let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kNFvF"), load("fliVL"), load("1uNFv")]).then(() => parcelRequire('nPAxe'));